// extracted by mini-css-extract-plugin
export default {"button":"Button_button__jKv8p","small":"Button_small__26Jfg"};